import { Box, SxProps, Theme } from "@mui/material";

import { onlyInSchemeSx } from "@/src/theme/schemeStyles";

import katsastusLogoSquare from "@/assets/images/A-Katsastus_logo-square_transparent.webp";
import katsastusLogoWide from "@/assets/images/A-Katsastus_logo-vaaka_transparent.webp";
import katsastusLogoSquareWhite from "@/assets/images/A-Katsastus_logo-white-square_transparent.webp";
import katsastusLogoWideWhite from "@/assets/images/A-Katsastus_logo-white-vaaka_transparent.webp";

/** `square` stacks the roundel over the wordmark; `wide` sets them side by side. */
export type KatsastusLogoVariant = "square" | "wide";

const KATSASTUS_LOGO_SOURCES: Record<
  KatsastusLogoVariant,
  { light: string; dark: string }
> = {
  square: { light: katsastusLogoSquare, dark: katsastusLogoSquareWhite },
  wide: { light: katsastusLogoWide, dark: katsastusLogoWideWhite }
};

export interface KatsastusLogoProps {
  variant?: KatsastusLogoVariant;
  alt?: string;
  sx?: SxProps<Theme>;
}

/**
 * A-Katsastus partner logo.
 *
 * The artwork is flat ink with no backing plate, so the standard dark-blue
 * lockup disappears against the dark surfaces. Dark mode swaps in the white
 * lockup the partner ships for exactly this case, rather than filtering the
 * original, which would also strip the roundel's counters.
 *
 * Both lockups are rendered and CSS shows the one for the reader's scheme, so
 * prerendered pages show the right logo before React has loaded.
 */
const KatsastusLogo = (props: KatsastusLogoProps) => {
  const { variant = "square", alt = "A-Katsastus", sx } = props;
  const sources = KATSASTUS_LOGO_SOURCES[variant];
  const callerSx = Array.isArray(sx) ? sx : [sx];

  return (
    <>
      <Box
        component="img"
        src={sources.light}
        alt={alt}
        sx={[...callerSx, onlyInSchemeSx("light")]}
      />
      <Box
        component="img"
        src={sources.dark}
        alt={alt}
        sx={[...callerSx, onlyInSchemeSx("dark")]}
      />
    </>
  );
};

export default KatsastusLogo;
